export const modelsConstants = {
  INIT: 'MODELS_INIT',
  SUCCESS: 'MODELS_SUCCESS',
  ADD: 'MODELS_ADD',
  UPDATE: 'MODELS_UPDATE',
  FAILURE: 'MODELS_FAILURE',
  REMOVE: 'MODELS_REMOVE',
  CLEAR: 'MODELS_CLEAR',
}
